import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/builds/masterbranch1/smg-lsi/smg-lsi-admin/layouts/auth.vue")),
  default: defineAsyncComponent(() => import("/builds/masterbranch1/smg-lsi/smg-lsi-admin/layouts/default.vue"))
}